export default "__VITE_ASSET__X9IJfTgm__"